import { Loading } from 'e4shared';
import React from 'react';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { apiPost } from 'services';
import { useSelector } from 'react-redux';

export const SalesforceCallback = ({ history, location }) => {
    const values = queryString.parse(location.search);
    const code = values.code;
    const user = useSelector(state => state.user.user);

    if (!code) history.replace('/error');

    React.useEffect(() => {
        if (code && user) {
            apiPost('salesforce-callback?', { code }, user.guid, () => {
                history.replace('/admin/integrations?show=Salesforce');
            });
        }
    }, [code, user]);

    return <Loading />;
};

export default withRouter(SalesforceCallback);
